<template>
<div>
  <div>
    <button class="btn btn-primary float-end mb-2" @click="addRole">Add News Announcement</button>
  </div>
  <div>
     <TableFilter @changeText="changeTblFilter" />
    <table class="table table-sm">
      <thead>
      <tr>
          <SortColumn @click="sortColumn" sortBy="name" colGroup="tbl1">Title</SortColumn>
          <SortColumn @click="sortColumn" sortBy="corporateType" colGroup="tbl1">Detail</SortColumn>
          <SortColumn @click="sortColumn" sortBy="corporateType" colGroup="tbl1">Status</SortColumn>
        <th></th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(i, idx) in tableParam.listData" :key="idx">
          <td>{{i.title}}</td>
          <td><span v-html="i.detail"></span></td>
          <td><span v-if="i.status == true" class="badge bg-success">Active</span>
            <span v-else class="badge bg-danger">Inactive</span></td>
          <td><button class="btn btn-sm btn-primary" @click="clickEdit(i)">Edit</button></td>
        </tr>
      </tbody>
    </table>
    <Pagination
      :pagingParam="tableParam"
      @updatePaging="updatePaging"
    />
  </div>
</div>  
</template>

<script>

import api from "@/common/api";
import apiUrl from "@/common/apiurl";
import * as TableAddons from "@/components/custom/table_addons";

export default {
  name: 'NewsAnnouncements',
  components: {
    ...TableAddons
  },
  data() {
    return {
      tableParam: this.dtoPaging()
    }
  },
  destroyed() {
    this.clearBreadcrumb();
  },
  mounted() {
    this.setBreadcrumb([
      { name: 'News Announcements' }
    ]);
    this.callTable();
  },
  methods: {
    callTable() {
      this.tableParam.listData = [];
      api.regularPost(apiUrl.newsAnnouncements.getList, this.tableParam).then((response) => {
        if (response.status == 200) {
          this.tableParam = response.data;
        }
      });
    },
    clickEdit(data) {
      this.$router.push({ name: 'AddEditNewsAnnouncement', params: { id: data.oid } });
    },
    addRole() {
      this.$router.push({ name: 'AddEditNewsAnnouncement' });
    },
    sortColumn(sortyBy, sortDir) {
      this.tableParam.orderby = sortyBy;
      this.tableParam.orderDir = sortDir;
      this.callTable();
    },
    updatePaging(paramObj) {
      this.tableParam.currentpage = paramObj.currentPage;
      this.tableParam.rowPerPage = paramObj.rowPerPage;
      this.callTable();
    },
    changeTblFilter(text) {
      this.tableParam.searchtext = text;
      this.callTable();
    },
  }
}
</script>
